module.exports = __webpack_public_path__ + "assets/img/fr-0607b864.png";